import { pipe } from '@mobily/ts-belt'
import { createEvent, createStore, sample } from 'effector'
import { selectEpgProgramModel } from '~/features/epg/programs/select'
import { model as clock } from '~/shared/clock'
import { F, T } from '~/shared/helpers'
import { type EpgSidebarInfo } from './index.h'
import {
  formatProgramToLocalizedView,
  formatProgramToView,
  formatToView,
} from './lib'

export const init = createEvent()

// reset widget on sign out
export const reset = createEvent()

// reset widget on epg page left
export const left = createEvent()

// sidebar state (open/close)
export const open = createEvent()
export const close = createEvent()
export const $open = createStore(false) //
  .on(open, T)
  .on(close, F)

// sidebar showing info
export const setInfo = createEvent<EpgSidebarInfo | null>()
export const $info = createStore<EpgSidebarInfo | null>(null) //
  .on(setInfo, (_, info) => info)

// open sidebar on program select
sample({
  clock: selectEpgProgramModel.select,
  filter: (program) => !program?.isCatchup,
  target: open,
})

sample({
  clock: close,
  target: selectEpgProgramModel.deselect,
})

// open sidebar on info button click
export const openInfo = createEvent()
sample({
  clock: openInfo,
  target: open,
})

// update sidebar info on program select
sample({
  clock: [selectEpgProgramModel.$program, clock.$minutes],
  source: {
    selected: selectEpgProgramModel.$program,
    now: clock.$minutes,
  },
  fn: ({ selected, now }) => {
    if (selected == null || selected.program == null) return null
    return pipe(
      selected,
      formatProgramToView,
      formatProgramToLocalizedView({ now }),
      formatToView
    )
  },
  target: setInfo,
})

//
// left and reset logic
//

sample({
  clock: [left, reset],
  target: [$open.reinit, $info.reinit, selectEpgProgramModel.$selected.reinit],
})
